import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Order({ order, setCart }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [date, setDate] = useState("");
  const [products, setProducts] = useState([]);
  useEffect(() => {
    order?.createdAt &&
      setDate(new Date(order?.createdAt).toLocaleDateString("en-GB"));

    setProducts(
      order?.meals?.map((meal) => {
        return {
          id: meal.meal.id,
          name: meal.meal.name,
          price: meal.meal.price,
          amount: meal.amount,
          images: meal.meal.images,
        };
      })
    );
  }, [order]);

  return (
    <div className="order">
      <div>
        <div className="order-number">
          <p>{t("order")} №814932340</p>
        </div>
        <div className="order-date">
          <p>{date ? date : ""}</p>
        </div>
      </div>
      <div className="order-products">
        {products?.map((product) => {
          return (
            <div
              className="image"
              onClick={() => {
                navigate(`/menu/product/${product.id}`);
              }}
            >
              <img
                src={
                  product?.images?.length > 0
                    ? product?.images[0]?.url
                    : "https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
                }
                alt="Not found"
              />
            </div>
          );
        })}
      </div>
      <div className="buttons">
        <div className="order-again">
          <button onClick={() => setCart(products)}>{t("order-again")}</button>
        </div>
      </div>
    </div>
  );
}
